import React from 'react';
import { render } from 'react-dom';
import * as Sentry from '@sentry/react';
import '@definedcrowd/Uicomponents/dist/style';
import './index.css';
import App from './App';

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({ dsn: window._env_.SENTRY_DSN, environment: window._env_.ENVIRONMENT_NAME });
}

render(<App />, document.getElementById('root'));
